import { classNames } from "@/helpers/common/classNames";
import { formatNumber } from "@/helpers/common/formatNumber";
import { NavigationChild } from "@/types/longhouseTypes";
import React from "react";
import { Link } from "react-router-dom";

interface NavItemProps {
    item: NavigationChild;
    isActive: boolean;
    disabled?: boolean;
}

export const SidebarNavItemChild: React.FC<NavItemProps> = ({
    item,
    isActive,
    disabled = false,
}) => {
    return (
        <li>
            <Link
                to={disabled ? "#" : item.href}
                onClick={(e) => disabled && e.preventDefault()}
                className={classNames(
                    isActive
                        ? "bg-brand text-white"
                        : "hover:bg-brand text-slate-700 hover:text-white dark:text-slate-200 dark:hover:text-white",
                    disabled
                        ? "group flex cursor-not-allowed items-center justify-between gap-x-3 rounded-md px-3 py-2 text-sm leading-6 font-medium opacity-50"
                        : "group flex items-center justify-between gap-x-3 rounded-md px-3 py-2 text-sm leading-6 font-medium",
                )}
                aria-disabled={disabled}
                tabIndex={disabled ? -1 : 0} // Optional: Make the link unfocusable if disabled
            >
                <span className="flex items-center gap-x-3">{item.name}</span>
                {item.count != null && item.count > 0 && (
                    <span className="ml-2 inline-flex h-6 w-19 items-center justify-center rounded-full bg-red-500 p-1 text-[9px] font-medium text-white dark:bg-red-400 dark:text-white">
                        {formatNumber(item.count)}
                    </span>
                )}
                {disabled && (
                    <span className="ml-2 inline-flex h-6 w-16 items-center justify-center rounded-full bg-slate-200 p-1 text-[8px] font-medium text-slate-800 dark:bg-slate-600 dark:text-slate-100">
                        Coming Soon
                    </span>
                )}
            </Link>
        </li>
    );
};
